import { createFileRoute, redirect } from '@tanstack/react-router'
export const Route = createFileRoute('/_auth/_main/campaigns/$campaignId/settings/lead-form')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/campaigns/$campaignId/settings/candidate-sources',
            params,
            search: { source: 'facebook' },
        })
    },
})
